import React from "react";
import { Layout,} from "antd";

import "./style.css";
import FooterComponent from "../Components/FooterComponent";
import HeaderComponent from "../Components/HeaderComponent";
import { useTranslation } from "react-i18next";
import about1 from "../Image/about1.jpg";
const {  Content,  } = Layout;

const About = () => {
  return (
    <Layout>
      <HeaderComponent />
      <Content
        style={{
          padding: "2rem",
          // margin: "2rem",
          minHeight: "calc(100vh - 200px)",
          backgroundColor: "#e6edff",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <h1
            className="heading"
            style={{ marginBottom: "2rem", fontWeight: 400 }}
          >
Connecting Canada with the Caribbean
            {/* {t("about.title")} */}
          </h1>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="flexDiv">
            <div className="contentParagraphDiv">
              <p className="contentParagraph">
                {/* {t("about.main")} */}
                Welcome to BajCan, more than just a remittance service. We are your reliable 
                connection between Canada, Barbados and other destinations across the Caribbean, 
                helping you keep close to your family and friends, no matter the distance.
                <br /> <br /> BajCan was established by members of
                 the Barbadian and Canadian communities to address a need for better and more 
                 reliable
                  remittance services. We have experienced the complexities of international money 
                  transfers firsthand. This understanding fuels our commitment to offer a service that is not only efficient but also attuned to your needs.
                <br />
                <br /> Our goal is to keep families, communities and businesses connected across the miles. By providing a dependable,
                 cost-effective, and easy-to-use remittance service, we enable individuals in Canada and Barbados to support their loved ones and foster the well-being of both nations.
                <br />
                <br />
                Sign up with BajCan today and discover a service that genuinely understands
                 and addresses your specific needs.
                <br /> <br /> 
              </p>
            </div>
            <img
              src={about1}
              alt="image1"
              className="aboutImage"
              style={{ maxWidth: "420px",  alignSelf:'center', maxHeight:"400px", width: "100%", height: "100%", marginLeft: "20px", paddingBottom:50}}
              />
          </div>
        </div>
      
       
      </Content>
      <FooterComponent />
    </Layout>
  );
};
export default About;
